var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfo3 = function SvgInfo3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_20530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6 4.5C11.84 4.5 10.4 5.94 10.4 7.7V14.1C10.4 15.86 11.84 17.3 13.6 17.3H16.8L19.2625 20.9937C19.6129 21.5202 20.3871 21.5202 20.7375 20.9937L23.2 17.3H26.4C28.16 17.3 29.6 15.86 29.6 14.1V7.7C29.6 5.94 28.16 4.5 26.4 4.5H13.6ZM12 22.1C10.2327 22.1 8.79998 23.5327 8.79998 25.3C8.79998 27.0673 10.2327 28.5 12 28.5C13.7673 28.5 15.2 27.0673 15.2 25.3C15.2 23.5327 13.7673 22.1 12 22.1ZM28 22.1C26.2327 22.1 24.8 23.5327 24.8 25.3C24.8 27.0673 26.2327 28.5 28 28.5C29.7673 28.5 31.2 27.0673 31.2 25.3C31.2 23.5327 29.7673 22.1 28 22.1ZM12 30.1C8.50398 30.1 5.59998 31.5541 5.59998 33.6469V34.9C5.59998 35.7832 6.31678 36.5 7.19998 36.5H16.8C17.6832 36.5 18.4 35.7832 18.4 34.9V33.6469C18.4 31.5541 15.496 30.1 12 30.1ZM28 30.1C24.504 30.1 21.6 31.5541 21.6 33.6469V34.9C21.6 35.7832 22.3168 36.5 23.2 36.5H32.8C33.6832 36.5 34.4 35.7832 34.4 34.9V33.6469C34.4 31.5541 31.496 30.1 28 30.1Z",
    fill: "#00CB82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_20530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#00CB82",
    transform: "translate(0 0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-3.49c04eb2.svg";
export { ForwardRef as ReactComponent };